import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import { useGetTabInfo } from 'screens/AssetManager';
import SessionHeader from './SessionHeader';
import SessionDetailsPage from './SessionDetailsPage';
import SessionAttendeesPage from './SessionAttendeesPage';
import { getSessionIsActiveTab, getSessionTabLink } from './utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function useGetSession(sessionId) {
  return {
    data: {
      id: sessionId,
      startDate: '2024-01-01T10:00:00Z'
    }
  }; // TODO: replace with actual data fetching logic in #17087
}
function SessionManager(_ref) {
  var _ref$inContentManager = _ref.inContentManagerContext,
    inContentManagerContext = _ref$inContentManager === void 0 ? false : _ref$inContentManager,
    _ref$inAssetManagerCo = _ref.inAssetManagerContext,
    inAssetManagerContext = _ref$inAssetManagerCo === void 0 ? false : _ref$inAssetManagerCo,
    sessionId = _ref.sessionId;
  var location = useLocation();
  var navigate = useNavigate();

  // Whether the SessionManager is nested e.g. inside the Asset Manager
  // which determines some of the UI (e.g. heading levels)
  var isNested = inContentManagerContext || inAssetManagerContext;
  var _useGetSession = useGetSession(sessionId),
    session = _useGetSession.data;
  var availableTabs = useMemo(function () {
    var tabs = ['details', 'attendees'];
    return tabs;
  }, []);
  var _useGetTabInfo = useGetTabInfo({
      getTabLink: getSessionTabLink,
      getIsActiveTab: getSessionIsActiveTab,
      location: location,
      tabs: availableTabs
    }),
    tabLinks = _useGetTabInfo.tabLinks,
    activeTab = _useGetTabInfo.activeTab;
  useEffect(function () {
    var _queryparse = queryparse(location.search),
      currentTab = _queryparse.sessionTab;
    if (currentTab !== null && currentTab !== undefined && !availableTabs.includes(currentTab)) {
      navigate(getSessionTabLink({
        tabName: 'details',
        location: location
      }), {
        replace: true
      });
    }
  }, [availableTabs, location, navigate]);
  var renderActiveTab = function renderActiveTab() {
    switch (activeTab) {
      case 'details':
        return /*#__PURE__*/_jsx(SessionDetailsPage, {
          isNested: isNested,
          session: session
        });
      case 'attendees':
        return /*#__PURE__*/_jsx(SessionAttendeesPage, {
          isNested: isNested,
          session: session
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SessionHeader, {
      isNested: isNested,
      session: session,
      tabLinks: tabLinks
    }), renderActiveTab()]
  });
}
export default SessionManager;